import { __module as c } from "./index829.mjs";
import { f as p } from "./index743.mjs";
import { f as u } from "./index758.mjs";
import { i as g } from "./index761.mjs";
import { h as m } from "./index811.mjs";
import { d as S } from "./index795.mjs";
import { f as y } from "./index830.mjs";
import { i as h } from "./index831.mjs";
import { i as v } from "./index786.mjs";
var n = p, I = u, E = g, i = m, o = S, d = y.CONFIGURABLE, N = h, l = v, O = l.enforce, b = l.get, s = String, a = Object.defineProperty, C = n("".slice), T = n("".replace), $ = n([].join), B = o && !I(function() {
  return a(function() {
  }, "length", { value: 8 }).length !== 8;
}), _ = String(String).split("String"), A = c.exports = function(r, t, e) {
  C(s(t), 0, 7) === "Symbol(" && (t = "[" + T(s(t), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), e && e.getter && (t = "get " + t), e && e.setter && (t = "set " + t), (!i(r, "name") || d && r.name !== t) && (o ? a(r, "name", { value: t, configurable: !0 }) : r.name = t), B && e && i(e, "arity") && r.length !== e.arity && a(r, "length", { value: e.arity });
  try {
    e && i(e, "constructor") && e.constructor ? o && a(r, "prototype", { writable: !1 }) : r.prototype && (r.prototype = void 0);
  } catch {
  }
  var f = O(r);
  return i(f, "source") || (f.source = $(_, typeof t == "string" ? t : "")), r;
};
Function.prototype.toString = A(function() {
  return E(this) && b(this).source || N(this);
}, "toString");
var M = c.exports;
export {
  M as m
};
